<template>
  <div style="display: flex; flex-wrap: wrap; gap: 4px; align-items: center">
    <EventTypeBadge :type="event.type" :size="size" />

    <span v-if="event.duration && showDuration" class="tag">
      {{ event.duration }}J
    </span>

    <span v-if="showSource" class="tag">
      {{ SOURCES[event.source] }}
    </span>

    <span v-if="event.zipCode && showDepartment" class="tag">
      {{ event.departement || `Dép. ${event.zipCode.substring(0, 2)}` }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { EventItem } from '@/types/Event';

const SOURCES: Record<string, string> = {
  scoringFit: 'Scoring Fit',
  competitionCorner: 'Comp. Corner',
  manual: 'Manuel',
  hyrox: 'Hyrox',
  maboxdecross: 'Ma Box de Cross',
};

withDefaults(
  defineProps<{
    event: EventItem;
    size?: 'sm' | 'md';
    showDuration?: boolean;
    showDepartment?: boolean;
    showSource?: boolean;
  }>(),
  {
    size: 'sm',
    showDuration: true,
    showDepartment: true,
    showSource: true,
  },
);
</script>
